module.exports = {"520323100":"洋川镇","520323101":"郑场镇","520323102":"旺草镇","520323103":"蒲场镇","520323104":"风华镇","520323105":"茅垭镇","520323106":"枧坝镇","520323107":"宽阔镇","520323108":"黄杨镇","520323109":"青杠塘镇","520323110":"太白镇","520323111":"温泉镇","520323112":"坪乐镇","520323200":"大路槽乡","520323201":"小关乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520323.json
// module id = 2280
// module chunks = 0